export default prevent => {
  if (prevent) document.documentElement.setAttribute('no-scroll', '')
  else document.documentElement.removeAttribute('no-scroll')
}
